import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e956577e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:!tw-p-4 md:!tw-overflow-y-auto md:!tw-h-full" }
const _hoisted_2 = { class: "rllg:tw-max-w-[705px] tw-px-4 tw-w-full tw-mx-auto md:!tw-px-0" }
const _hoisted_3 = { class: "tw-text-left rsm:tw-text-center tw-mb-8 rsm:tw-mb-14 tw-grid tw-gap-3 rsm:tw-gap-10" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-[.4rem]" }
const _hoisted_6 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-5 rsm:tw-mt-8" }

import { ref } from "vue";
import { BusinessDetailTypeEnum } from "@/core/enums/RolesEnum";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import { RolesEnum } from "@/core/enums/RolesEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeCompanySelect',
  props: {
  userName: { type: String },
  header: { type: String },
  selectionOptions: {
    type: Array<{
      id: number;
      component: any;
      title: string;
      description: string;
      value: RolesEnum | BusinessDetailTypeEnum;
    }>,
  },
},
  emits: ["onContinue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const selectedRole: any = ref("");
const onSelectRole = (role: RolesEnum | BusinessDetailTypeEnum) => {
  if (selectedRole.value === role) {
    selectedRole.value = "";
  } else {
    selectedRole.value = role;
  }
};

const onClickContinue = () => {
  emits("onContinue", selectedRole.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Text, {
          variant: "h4",
          class: "!leading-normal rsm:!tw-text-[32px]"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Welcome "),
            (__props.userName)
              ? (_openBlock(), _createBlock(Text, {
                  key: 0,
                  variant: "h4",
                  class: "!leading-normal rsm:!tw-text-[32px]",
                  isCapitalize: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(", " + _toDisplayString(__props.userName), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" 👋")
          ]),
          _: 1
        }),
        _createVNode(Text, {
          variant: "h4",
          textWeight: "500",
          class: "!leading-normal rsm:!tw-text-[32px]"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.header), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "tw-max-w-[650px] tw-w-full tw-mx-auto tw-grid rsm:tw-grid-cols-2 tw-gap-4 rsm:tw-gap-12",
        onKeydown: _withKeys(onClickContinue, ["enter"]),
        tabindex: "0"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectionOptions, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option?.id,
            onClick: ($event: any) => (onSelectRole(option.value)),
            class: _normalizeClass([{
            'tw-border-[#3366FF] tw-border-solid tw-border-[3px]':
              selectedRole.value === option.value,
          }, "onboarding-card tw-w-full tw-bg-white tw-min-h-[236px] rsm:tw-min-h-[300px] tw-rounded-[16px] tw-text-center tw-bg-transparent tw-p-8 rsm:py-10 rsm:tw-px-6 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-cursor-pointer"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(option.component), { class: "tw-max-w-[200px] tw-h-[100px] rsm:tw-h-[120px]" })),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(Text, {
                variant: "h6",
                class: "rsm:!tw-text-[20px]",
                textAlign: "center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(Text, {
                variant: "span",
                textWeight: "500",
                class: "rllg:!tw-text-[14px]",
                textColor: "rgba(12, 15, 74, 0.5)",
                lineHeight: "16px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.description), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ], 10, _hoisted_4))
        }), 128))
      ], 32),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button, {
          class: "rsm:!tw-w-auto rsm:!tw-min-w-[400px]",
          label: "continue",
          variant: "accent",
          disabled: !selectedRole.value,
          onClick: onClickContinue
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})